import {Pipe, PipeTransform} from '@angular/core';
import {Zone} from './zone';

@Pipe({
    name: 'zahZones',
    standalone: false
})
export class ZonesPipe implements PipeTransform {
  transform(zoneIds: Array<string>, zones: Array<Zone>): string {
    if (!zones) {
      return '';
    } else {
      const zoneLabels = (zoneIds || [])
        .map(zoneId => zones.find(zone => zone.getId() === zoneId))
        .filter(zone => !!zone)
        .map(zone => zone.getLabel());
      return zoneLabels.length > 0 ? zoneLabels.join(', ') : 'Geen zone';
    }
  }
}
